<template>
    <div class="works">
        <div class="box-hd mt45 tcenter" v-if="types == 'yzzp'">
            <img src="https://havalclub.oss-cn-beijing.aliyuncs.com/greatwallAMP/image/test-gzcarshow/16058400747831.png" class="btn-img btn-yzzp"/>
        </div>
        <div class="more" @click="handleMore('more')">查看全部{{num}}篇</div>
        <ul class="box-imgs">
            <li v-for="(item,index) in dataLists" :key="index"  @click="handleMore('detail', item.threadBasic.id)">
                <div class="box-item">
                    <div class="cover" :style="`background-image: url(${item.threadBasic.picture})`"></div>
                    <div class="title">{{item.threadBasic.title}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import jsApp from '@/utils/jsApp'
import API from '@/api/gzCarShowAPI';
import { Toast } from 'vant';
export default {
    props: ['types'],
    data() {
        return {
            dataLists: [],
            num: 0,
            moreId: '',
            images: [],
        }
    },
    mounted() {
        this.getHotContentList();
    },
    methods: {
        // 获取图集信息
        async getHotContentList(){
            let params;
            switch(this.types) {
                case 'zxjj': // 资讯聚集
                //    params  = {nodeId: 'haval_serviceCH_kownsPG_subjectMDL'}; // 测试
                   params  = {nodeId: 'haval_autoShowCH_infoPG_infoMDL'};
                   break;
                case 'yzzp': // 优质作品
                    // params  = {nodeId: 'haval_serviceCH_userServicePG_subjectMDL'}; // 测试
                    params  = {nodeId: 'haval_autoShowCH_hotPG_infoMDL'};
                   break;
            }
            let  headers = {brand: 1, enterPriseId: 'CC001', rs: 2, terminal: 'GW_APP_Haval'};
            const res = await API.getHotContentList(params, headers);
            if(res.code == '000000') {
                var thematic = res.data[0].children[0].contentMessageList[0].objList[0];
                this.num = thematic.subjectContentEffectiveNumber;
                this.moreId = thematic.id;
                this.queryPostsList(thematic)
            }else{
                Toast.fail(res.errmsg);
            }
        },
        async queryPostsList(thematic, ){
            let params = {
                "queryParam": {"subjectId": thematic.id},
                "sortParam": {
                    "order": "0",
                    "type": "0"
                },
                "pageParam": {
                    "pageSize": 10,
                    "pageNo": 1
                }
            };
            let  headers = {brand: 1, enterPriseId: 'CC001', rs: 2, terminal: 'GW_APP_Haval'};
            const res = await API.queryPostsList(params, headers);
            if(res.code == '000000') {
                let data = res.data.list;
                this.dataLists = data;
            }else{
                Toast.fail(res.errmsg);
            }
        },
        handleMore(type, detailId) {
            switch(type) {
                case 'more':
                    jsApp.isMore('haval','home/informationDetail?thematicId=' + this.moreId);
                    break;
                case 'detail':
                    jsApp.isMore('haval','community/postDetail?id=' + detailId);
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.works{
    padding: 0 0 0 20px;
    .btn-img{
        width: 200px;
        margin: 0 auto;
    }
    .more{
        margin: 8px 12px 8px 8px;
        color: #ffffff;
        text-align: right;
        padding-right: 30px;
        font-family: PingFangSC;
        font-size: 16px;
        line-height: 32px;
        background-image: url(https://imgamp.gwm.com.cn/web/img/activity/bj-car-exhibition/more.png);
        background-position: right;
        background-repeat: no-repeat;
        background-size: 18px;
    }
}
.box-imgs{
    display: flex;
    overflow-x: scroll;
    li{
        width: 244px;
        background-image: url(../../../images/hot_border.png);
        overflow: hidden;
        background-size: contain;
        background-repeat: no-repeat;
        padding: 8px;
        box-sizing: border-box;
        border-radius: 4px 4px 0px 0px;
        flex-shrink: 0;
        margin-right: 32px;
        .cover{
            width: 234px;
            height: 158px;
            border-radius: 4px 4px 0px 0px;
            background-image: linear-gradient(226deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.00) 100%);
            background-size: cover;
            background-position: center;
        }
        .title{
            color: #fff;
            font-size: 14px;
            width: 234px;
            height: 60px;
            line-height: 20px;
            padding: 20px 6px;
            box-sizing: border-box;
            font-family: PingFangSC;
            overflow-wrap: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
    li:last-child{
        width: 270px;;
        height: 240px;
        .cover{
            width: 234px;
            height: 160px;
        }
    }
}
</style>